import {
    Component,
    ViewChild,
    Injector,
    Output,
    EventEmitter,
    ElementRef,
    ViewEncapsulation,
    Input,
} from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { ModalDirective } from "ngx-bootstrap";
import { AppComponentBase } from "@shared/common/app-component-base";
import {
    EventsServiceProxy,
    EventToSignUpDto,
} from "@shared/service-proxies/service-proxies";

@Component({
    selector: "eventInformationsModal",
    templateUrl: "./event-informations-modal.component.html",
})
export class EventInformationsModalComponent extends AppComponentBase {
    @ViewChild("createOrEditModal") modal: ModalDirective;

    active = false;
    event: EventToSignUpDto = new EventToSignUpDto();

    constructor(
        injector: Injector,
        private _eventsService: EventsServiceProxy
    ) {
        super(injector);
    }

    ngAfterViewChecked(): void {
        //Temporary fix for: https://github.com/valor-software/ngx-bootstrap/issues/1508
        $("tabset ul.nav").addClass("m-tabs-line");
        $("tabset ul.nav li a.nav-link").addClass("m-tabs__link");

        //Ajuste para melhorar performance da modal
        this.modal.config.animated = false;
        this.modal.config.backdrop = "static";
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }

    onShown(): void {
        this.modal.show();
    }

    public show(eventId?: number): void {
        this.event = new EventToSignUpDto();
        this.active = true;

        eventId = eventId ? eventId : 0;

        this._eventsService.getEventForSignUp(eventId).subscribe((result) => {
            if (result.event) {
                this.event = result.event;
            }

            this.modal.show();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/event/event-informations-modal/event-informations-modal.component.ts